import { useMemo } from 'react';
import { Select } from 'shared/components/common/Select/Select';
import { AnswerProps } from '../PollQuestions';
import styles from './MultipleAnswers.module.scss';
import { useTranslation } from 'react-i18next';

const MultipleAnswers = ({ answersVariat, answer, setAnswer }: AnswerProps) => {
  const { t } = useTranslation('polls');
  let answersVariatOptions = useMemo(() => {
    return answersVariat.map((variant, index) => {
      return { label: variant, id: index };
    });
  }, [answersVariat]);

  return (
    <div className={styles.wrapper}>
      <p>{t('multiple.text')}</p>
      <Select multiselect options={answersVariatOptions} alwaysOpen onSelect={(value) => setAnswer(value)} value={answer} />
    </div>
  );
};

export default MultipleAnswers;
